import { QUERY_KEYS } from 'api/query-keys';
import { sharedWorkforceService } from 'api/services';
import { WorkforceSource } from 'api/services/workforce/workforce-service.dto';
import { useInfiniteQuery } from 'react-query';

export const useGetWorkforce = (
  workforceSource: WorkforceSource,
  employmentTypes?: string[],
  filter?: string
) => {
  return useInfiniteQuery({
    queryKey: QUERY_KEYS.workforceBySource(workforceSource, employmentTypes, filter),
    queryFn: async ({ pageParam = 0 }) =>
      await sharedWorkforceService.getEmployees({
        pageParam,
        labourEngagementStates:
          workforceSource === 'own' ? ['approved', 'pending', 'rejected'] : undefined,
        workforceSource,
        employmentTypes,
        filter,
      }),
    getNextPageParam: (lastGroup) => lastGroup.nextPage,
  });
};
